import { Table, TableCell, TableRow } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledTable = styled(Table)(({ theme }) => ({
  border: '1px solid',
  borderColor: theme.palette.divider,
}));

export const StyledTableHeadRow = styled(TableRow)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
}));

export const StyledTableHeadCell = styled(TableCell)(({ theme }) => ({
  fontWeight: 600,
  borderBottom: '1px solid',
  borderColor: theme.palette.divider,
}));

export const StyledTableRow = styled(TableRow)<{ isEven?: boolean }>(({ isEven, theme }) => ({
  borderBottom: '1px solid',
  borderColor: theme.palette.divider,
  backgroundColor: isEven ? theme.palette.background.paper : 'transparent',
}));

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  borderBottom: '1px solid',
  borderColor: theme.palette.divider,
}));

export { TableHead } from '@mui/material';
